import AddModulesStep from "./AddModulesStep/AddModulesStep";
import CollectionCreationResultStep from "./CollectionCreationResultStep";
import CollectionDetailsStep from "./CollectionDetailsStep";
import ReviewCollectionChangesStep from "./ReviewCollectionChangesStep";
import React from "react";

const CollectionCreatorSteps = ({
    isEditMode,
    authorsDict,
    setAuthorsDict,
    collection,
    createdModules,
    currentStep,
    currentUser,
    goToNextStep,
    goToPreviousStep,
    modules,
    updateState,
    videoBank,
    showUrlImport,
    importInProgress,
    policyModel,
    addNewSampleModule
}) => {
    let content = null;

    if (currentStep === 0) {
        content = (
            <CollectionDetailsStep
                authorsDict={authorsDict}
                collection={collection}
                currentUser={currentUser}
                goToNextStep={goToNextStep}
                updateState={updateState}
                showUrlImport={showUrlImport}
                modules={modules}
                importInProgress={importInProgress}
                addNewSampleModule={addNewSampleModule}
            />
        );
    } else if (currentStep == 1) {
        content = (
            <AddModulesStep
                isEditMode={isEditMode}
                authorsDict={authorsDict}
                collection={collection}
                createdModules={createdModules}
                currentUser={currentUser}
                goToNextStep={goToNextStep}
                goToPreviousStep={goToPreviousStep}
                modules={modules}
                updateState={updateState}
                videoBank={videoBank}
                addNewSampleModule={addNewSampleModule}
                setAuthorsDict={setAuthorsDict}
                policyModel={policyModel}
            />
        );
    } else if (currentStep == 2) {
        content = (
            <ReviewCollectionChangesStep
                isEditMode={isEditMode}
                authorsDict={authorsDict}
                collection={collection}
                currentUser={currentUser}
                modules={modules}
                setAuthorsDict={setAuthorsDict}
                updateState={updateState}
                goToNextStep={goToNextStep}
                goToPreviousStep={goToPreviousStep}
            />
        );
    } else if (currentStep == 3) {
        content = (
            <CollectionCreationResultStep
                isEditMode={isEditMode}
                goToPreviousStep={goToPreviousStep}
            />
        );
    }

    return (
        <div className="step-fade" key={`step-${currentStep}`}>
            {content}
        </div>
    );
};

export default CollectionCreatorSteps;
